import {Navigate, Outlet} from "react-router";
import {useAppSelector} from "../../stores/hooks";
import {usePassportService} from "../../@vodea/utilities/hooks";
import VuiLoadingScreen from "../../@vodea/vodea-ui/components/LoadingScreen";

const AuthLayout: React.FC<any> = () => {
    const {isOnFetchingUser} = usePassportService()
    const system = useAppSelector((state) => state.system)

    if (isOnFetchingUser) {
        return <VuiLoadingScreen/>
    }

    if (system.isLoggedIn) {
        return <Navigate to={'/'} replace/>;
    }

    return (
        <section id={'auth-layout'}>
            <div className="container-wrapper">
                <div className="container">
                    <Outlet/>
                </div>
            </div>
        </section>
    )
}

export default AuthLayout
